import { ICalculatorTheme } from '../../models/CalculatorTheme';
import { colors } from './colors';

export const calculatorTheme: ICalculatorTheme = {
  helperText: {
    color: colors.notTransactional.base,
    lineHeight: '20px',
    textDecoration: 'none',
    error: {
      marginTop: '4px',
    },
    success: {
      marginTop: '15px',
    },
  },
  infoIcon: {
    fillColor: colors.notTransactional.base,
    marginLeft: '8px',
  },
  calculatorWrapper: {
    mobile: {
      padding: '8px',
    },
    desktop: {
      padding: '8px',
    },
    backgroundColor: colors.neutral.grayLight,
  },
  calculatorHeader: {
    mobile: {
      color: colors.neutral.gray,
      fontSize: '17px',
    },
    desktop: {
      color: colors.neutral.gray,
      fontSize: '20px',
    },
  },
  inputTitle: {
    fontWeight: 700,
    lineHeight: '20px',
    marginBottom: '2px',
    color: colors.neutral.gray,
  },
  estimationContainer: {
    color: colors.neutral.gray,
    backgroundColor: colors.neutral.white,
  },
  popover: {
    title: {
      color: colors.neutral.gray,
    },
    body: {
      color: colors.neutral.grayBoulder,
    },
  },
  inputContainer: {
    desktopGap: '16px',
    desktopWidth: 'calc(50% - 8px)',
    superDesktopGap: '16px',
    superDesktopWidth: 'calc(50% - 8px)',
  },
};
